// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"c43d9ecf67ecd5d2","4054":"06446f1fead9fe40","6082":"06446f1fead9fe40"}[chunkId] + ".css";
};